import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66739caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Experience")
], -1))
const _hoisted_2 = { class: "timeline timeline-second-style clearfix" }
const _hoisted_3 = { class: "left-part" }
const _hoisted_4 = { class: "item-period" }
const _hoisted_5 = { class: "item-company" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_7 = { class: "right-part" }
const _hoisted_8 = { class: "item-title" }
const _hoisted_9 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.experience, (exp, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "timeline-item clearfix"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h5", _hoisted_4, _toDisplayString(exp.period), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(exp.company), 1)
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", _hoisted_8, _toDisplayString(exp.position), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(exp.description), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}